import React, {FC} from 'react';

import {UnreachableError} from '../../../../libs/shared/helpers/src/types/customErrors';
import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {RuleEditorTriggerGroupsEnum} from '../ruleTriggerModel';

/*
 * Types.
 */

interface RuleTriggerGroupIconProps {
  id: RuleEditorTriggerGroupsEnum;
}

/*
 * Component.
 */

export const RuleTriggerGroupIcon: FC<RuleTriggerGroupIconProps> = ({id}) => {
  const theme = useUserTheme();
  return <Icon name={getIconName(id)} color={theme.greys.shade80} />;
};

/*
 * Helpers.
 */

export const getIconName = (id: RuleEditorTriggerGroupsEnum): IconName => {
  switch (id) {
    case RuleEditorTriggerGroupsEnum.MESSAGE:
      return 'sendFilled';

    case RuleEditorTriggerGroupsEnum.STATUS:
      return 'archiveFilled';

    case RuleEditorTriggerGroupsEnum.TEAMMATE:
      return 'teammatesFilled';

    case RuleEditorTriggerGroupsEnum.TAG:
      return 'tagFilled';

    case RuleEditorTriggerGroupsEnum.TOPIC:
      return 'integration';

    default:
      throw new UnreachableError(id);
  }
};
